import { post } from 'aws-amplify/api';
import { PRESCRIPTSURE } from '../constants/api-endpoints';
import { getSessionToken } from './service-config';
const apiNamePath = PRESCRIPTSURE.SUPPORT_FEEDBACK_API;

const supportFeedbackApiService = {
  async submitUserFeedback({
    firstName,
    lastName,
    queryType,
    email,
    subject,
    message,
  }) {
    try {
      const sessionToken = await getSessionToken();

      const submitUserFeedbackOperation = post({
        apiName: apiNamePath,
        path: '/user_feedback',
        options: {
          headers: {
            Authorization: `Bearer ${sessionToken}`,
          },
          queryParams: {},
          body: {
            first_name: firstName,
            last_name: lastName,
            user_email: email,
            category: queryType,
            message: message,
            subject: subject,
          },
        },
      });

      const submitUserFeedbackResults = (
        await submitUserFeedbackOperation.response
      ).body.json();

      return submitUserFeedbackResults;
    } catch (error) {
      console.error('Error fetching subscription plan information:', error);
    }
  },
};

export default supportFeedbackApiService;
